/** @jsx jsx */
import { gql } from '@apollo/client';
import { P } from '@bottlebooks/gatsby-design-system';
import { Trans } from '@lingui/macro';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import Section from '../Section/Section';

/**
 *
 * @param {object} props
 * @param {object} props.wine
 * @param {React.ReactNode} [props.children] Optional details on the winemaker, can be supplied by shadowing components.
 */
export default function WineWinemaker({ wine, children, ...rest }) {
  if (!wine || !wine.winemaker) return null;
  return (
    <Section title={<Trans>Winemaker</Trans>} {...rest}>
      <P variant="title">{wine.winemaker}</P>
      {children}
    </Section>
  );
}

export const fragment = graphql`
  fragment bb_WineWinemaker on Bottlebooks_Wine {
    winemaker
  }
`;

WineWinemaker.fragment = gql`
  fragment WineWinemaker on Wine {
    winemaker
  }
`;
